export default `query OrderData ($orderId: String!){
    orderData(orderId: $orderId) {
        items
        order_id
        order_number
        total
        order_info {
            status
            created_at
            discount_amount
            erp_voucher_codes
            grand_total
            loyalty_amount
            payment_method
            shipping_amount
            subtotal
            total_item_count
            shipping_method
            order_discounts{
                general_code
                journal
                voucher
                voucher_amount
                title
                rule_id
                rule_name
                discount_type
                discount_percent
            }
            payment_methods {
                code
                title
            }
            order_address {
                city
                company
                country_code
                fax
                firstname
                lastname
                middlename
                order_comment
                postcode
                prefix
                region
                region_id
                street
                suffix
                telephone
                type_address
                vat_id
                ward
                ward_name
            }
        }
        order_items {
            name
            sku
            qty_ordered
            price
            original_price
            loyalty_amount
            erp_voucher_amount
        }
    }
}
`;
